import type { AxiosError } from 'axios'

import { getRuntimeConfig } from '@front/runtime-config'

import { AxiosInstance } from '../axios.instance'

import { logoutUser } from './logoutUser'

export const refreshToken = async (): Promise<boolean> => {
  const {
    public: { serviceAuthUrl },
  } = getRuntimeConfig()
  // eslint-disable-next-line no-restricted-syntax
  if (!localStorage.getItem('accessToken')) {
    return true
  }
  try {
    const res = await AxiosInstance.get(`${serviceAuthUrl}/token/refresh`)

    if (res.data?.token) {
      // eslint-disable-next-line no-restricted-syntax
      localStorage.setItem('accessToken', res.data.token)
    }

    return true
  } catch (err) {
    const error = err as AxiosError

    console.error(`An error has occured in refreshToken: ${error}`)

    if (error.response?.status === 401) {
      await logoutUser()
    }

    return false
  }
}
